import WithRender from "../../templates/buttons/connectButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowConnectButton",
      "getFilesConnectLoading",
      "getIsMyAccount"
    ]),
    name: function () {
      return "Connect";
    },
    getDisableClass: function () {
      return this.getFilesConnectLoading ? "disable" : "";
    }
  },
  methods: {
    ...mapActions(["connectUploads"]),
    connectButton: function () {
      this.connectUploads({ widget: this });
    }
  }
});
